// extracted by mini-css-extract-plugin
module.exports = {"root":"Attachment_root__3fDuJ","link":"Attachment_link__NPjd5","labelGroup":"Attachment_labelGroup__1a0h7","percentage":"Attachment_percentage__3rFk3"};